<template>
    <div v-if="hasFieldToDisplay()" style="margin-bottom: 50px">
        <div class="tabulation-title">
            <h5>
                <v-icon class="blue--text text--darken-2">label</v-icon> Location de salles
            </h5>
        </div>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="tabulation-title m-auto" v-if="hasCapacitiesToDisplay()">
                <h6>
                    <v-icon class="blue--text text--darken-2">label_outline</v-icon> Capacités
                </h6>
            </div>

            <div class="mt-5">
                <v-text-field label="Capacité max d'accueil (en personnes)" v-model="roomRenting.max_capacity"
                    type="number" v-if="hasField('MAX_CAPACITY_ACC')" outlined>
                </v-text-field>

                <v-text-field label="Nombre de salles de réunion équipées" v-model="roomRenting.equipped_room_nb"
                    type="number" v-if="hasField('ROOM_NUMBER')" outlined>
                </v-text-field>

                <v-text-field label="Nombre de salles modulables" v-model="roomRenting.multi_purpose_room_nb"
                    type="number" v-if="hasField('ROOM_MOD')" outlined>
                </v-text-field>
            </div>

            <div class="tabulation-title m-auto" v-if="hasPrestationsToDisplay()">
                <h6>
                    <v-icon class="blue--text text--darken-2">label_outline</v-icon> Prestations
                </h6>
            </div>

            <div class="mt-5">
                <v-autocomplete v-if="hasFamilyElement('SalleEquipeePour')" :value="SalleEquipeePour"
                    :items="getFamilyByCode('SalleEquipeePour')"
                    @change="updateOrDeleteElement($event, 'SalleEquipeePour')" chips deletable-chips
                    label="Espace adapté à des prestations de type" item-text="label" return-object multiple outlined>
                </v-autocomplete>

                <v-autocomplete v-if="hasFamilyElement('SalleEquipement')" :value="SalleEquipement"
                    :items="getFamilyByCode('SalleEquipement')"
                    @change="updateOrDeleteElement($event, 'SalleEquipement')" chips deletable-chips label="Équipement"
                    item-text="label" return-object multiple outlined>
                </v-autocomplete>

                <v-autocomplete v-if="hasFamilyElement('SalleRestauration')" :value="SalleRestauration"
                    :items="getFamilyByCode('SalleRestauration')"
                    @change="updateOrDeleteElement($event, 'SalleRestauration')" chips deletable-chips
                    label="Restauration" item-text="label" return-object multiple outlined>
                </v-autocomplete>

                <v-autocomplete v-if="hasFamilyElement('SalleHebergement')" :value="SalleHebergement"
                    :items="getFamilyByCode('SalleHebergement')"
                    @change="updateOrDeleteElement($event, 'SalleHebergement')" chips deletable-chips
                    label="Hébergement" item-text="label" return-object multiple outlined>
                </v-autocomplete>
            </div>

            <div v-if="hasRoomCapacitiesToDisplay() || hasRoomPropertiesToDisplay()">
                <div class="tabulation-title m-auto">
                    <h6>
                        <v-icon class="blue--text text--darken-2">label_outline</v-icon> Salles
                    </h6>
                </div>

                <div class="mt-5">
                    <room v-for="(room, index) in roomRenting.rooms" :room="room" :index="index" class="mb-5">
                    </room>

                    <div class="text-center w-100 mt-5">
                        <v-btn color="primary" @click="addNewRoom">
                            <v-icon small class="mr-2">add</v-icon>
                            Ajouter une salle
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import Room from "./Room"

export default {
    name: "RoomRenting",
    components: { Room },
    data() {
        return {
            SalleEquipeePour: [],
            SalleEquipement: [],
            SalleRestauration: [],
            SalleHebergement: []
        }
    },
    methods: {
        ...mapMutations('web_form', ['addRoom', 'addElement', 'removeElement', 'updateProvider']),
        hasFieldToDisplay() {
            return this.hasCapacitiesToDisplay() ||
                this.hasPrestationsToDisplay() ||
                this.hasRoomCapacitiesToDisplay() ||
                this.hasRoomPropertiesToDisplay()
        },
        hasCapacitiesToDisplay() {
            return this.hasField('MAX_CAPACITY_ACC') ||
                this.hasField('ROOM_NUMBER') ||
                this.hasField('ROOM_MOD')
        },
        hasPrestationsToDisplay() {
            return this.hasFamilyElement('SalleEquipeePour') ||
                this.hasFamilyElement('SalleEquipement') ||
                this.hasFamilyElement('SalleRestauration') ||
                this.hasFamilyElement('SalleHebergement')
        },
        hasRoomCapacitiesToDisplay() {
            return this.hasField('ROOM_U') ||
                this.hasField('ROOM_BANQUET') ||
                this.hasField('ROOM_SQUARE') ||
                this.hasField('ROOM_CLASS') ||
                this.hasField('ROOM_COCKTAIL') ||
                this.hasField('ROOM_THEATRE')

        },
        hasRoomPropertiesToDisplay() {
            return this.hasField('NAME') ||
                this.hasField('ROOM_DESCRIPTION') ||
                this.hasField('MAX_CAPACITY_PERS') ||
                this.hasField('AREA') ||
                this.hasField('ROOM_HEIGHT') ||
                this.hasField('NATURAL_LIGHT')
        },
        updateOrDeleteElement(newElements, property) {
            let currentElements = this[property]

            if (currentElements.length > newElements.length) {  // Cas suppression
                this.deleteElement(currentElements, newElements)
            } else { // Cas Ajout
                this.addNewElement(currentElements, newElements)
            }

            this[property] = newElements
        },
        addNewElement(currentElements, newElements) {
            let element = newElements
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            if (Array.isArray(newElements)) {
                let diff = newElements.filter(_element => !previousValue.includes(_element)) || []

                if (diff.length) {
                    element = diff[diff.length - 1]
                }
            } else if (previousValue) {
                this.removeElement(previousValue)
            }

            this.addElement(element)
        },
        deleteElement(currentElements, newElements) {
            const previousValue = JSON.parse(JSON.stringify(currentElements))

            const diff = previousValue.filter(element => {
                return !newElements.map(elt => elt.id).includes(element.id)
            }) || []

            let element = newElements

            if (diff.length) {
                element = diff[diff.length - 1]
            }

            this.removeElement(element)
        },
        addNewRoom() {
            let room = {
                area: null,
                banquet_capacity: null,
                classroom_capacity: null,
                cocktail_capacity: null,
                description: null,
                height: null,
                max_capacity: null,
                name: null,
                natural_light: false,
                square_capacity: null,
                theatre_style_capacity: null,
                u_shape_capacity: null
            }

            this.addRoom(room)
        }
    },
    computed: {
        ...mapState('web_form', ['disabled', 'roomRenting']),
        ...mapGetters('web_form', ['hasField', 'hasFamilyElement', 'getFamilyByCode', 'getElementsByFamilyCode'])
    },
    created() {
        this.SalleEquipeePour = this.getElementsByFamilyCode('SalleEquipeePour')
        this.SalleEquipement = this.getElementsByFamilyCode('SalleEquipement')
        this.SalleRestauration = this.getElementsByFamilyCode('SalleRestauration')
        this.SalleHebergement = this.getElementsByFamilyCode('SalleHebergement')
    }
}
</script>